'use client'

/* eslint-disable  @typescript-eslint/no-floating-promises */

import React, { useEffect, useRef } from 'react'
import { useRouter } from 'next/navigation'
import AckodriveBreadCrumb from '@components/Ackodrive/breadCrumb'
import CallbackWidget from '@components/Ackodrive/CallbackWidget'
import RecentItemPosts from '@components/Ackodrive/RecentItemPosts'
import { getCookie } from 'cookies-next'
import { pageEvent, waitForAnalyticsLoad } from '@acko-tech/building-blocks.ui.acko-analytics'
import { ITEM_TYPE, ITEM_ID, TEAM_ACKO } from '@components/Ackodrive/common/constants'
import TopicsPanel from '@components/Ackodrive/TopicPanel'
import { segmentEventCommonPropFuncAckoDrive } from '@utils/segmentProperties'
import assetLoader from '@utils/internalImageLoader'
import logger from '@utils/logger'
import Card from '../Card'
import RecentItems from '../ItemDetails/RecentItems'
import Paginator from '../Paginator'
import { extractCardHeroImageUrl, extractCardHeroDescription } from './utils'
import {
  ItemsListingWrapper,
  ItemListingContentWrapper,
  ItemListingLeftContainer,
  Divider,
  RightContainer,
  RightStickyContainer,
  RecentItemsContainer,
  CallbackWidgetExplore,
} from './styles'
import { ITEM_ID_VS_VIEW_LISTING_SEGMENT_EVENTS } from '../common/segementconstants'
import { cleanPathname } from '../common/urlValidation'

const ItemListing = ({
  allPostRes,
  recentPosts,
  total,
  limit,
  page,
  itemId = ITEM_ID.NEWS,
  itemType = ITEM_TYPE.NEWS,
  isMobileDevice,
  topicsData = [],
}) => {
  const refereshAccessToken: any = getCookie('ackodrive_tokens') || '{}'
  const isLoggedIn = !!Object.keys(JSON.parse(decodeURIComponent(refereshAccessToken))).length
  const hasRun = useRef(false)

  const router = useRouter()

  const breadcrumb = [
    {
      value: 'Home',
      url: '/',
    },
    {
      value: itemType,
      url: null,
    },
  ]

  const rangeLimit = Math.ceil(total / limit)
  const handlePaginationChange = pageNumber => {
    const pageNo = pageNumber
    router.push(`/${itemId}/page/${pageNo}/`, { scroll: true })
  }

  useEffect(() => {
    if (!hasRun.current) {
      waitForAnalyticsLoad()
        .then(() => {
          setTimeout(() => {
            const properties = segmentEventCommonPropFuncAckoDrive({ pageType: itemId })
            pageEvent(ITEM_ID_VS_VIEW_LISTING_SEGMENT_EVENTS[itemId], {
              ...properties,
            })
          }, 100)
        })
        .catch(err => {
          logger.info('Wait for analytics load error', err)
        })
      hasRun.current = true
    }
  }, [])

  return (
    <ItemsListingWrapper>
      <AckodriveBreadCrumb breadCrumbObj={breadcrumb} />
      <ItemListingContentWrapper isMobile={isMobileDevice}>
        <div>
          <ItemListingLeftContainer>
            {allPostRes?.data?.map((item, index) => (
              <Card
                key={index}
                image={
                  extractCardHeroImageUrl(item?.attributes?.contentBeforeToc) || {
                    url: `${assetLoader()}/images/acko.png`,
                    title: item?.attributes?.title || item?.attributes?.articleTitle,
                  }
                }
                title={item?.attributes?.title || item?.attributes?.articleTitle}
                url={
                  itemId === 'articles'
                    ? cleanPathname(`${item?.attributes?.url}`)
                    : cleanPathname(`/${itemId}/${item?.attributes?.slug}/`)
                }
                modifiedDate={item?.attributes?.updatedAt}
                description={extractCardHeroDescription(item?.attributes?.contentBeforeToc)}
                slug={item?.attributes?.slug}
                itemId={itemId}
                authorName={item?.attributes?.authorName?.data?.attributes?.name || TEAM_ACKO}
              />
            ))}
          </ItemListingLeftContainer>

          {rangeLimit > 1 && (
            <Paginator
              isMobile={isMobileDevice}
              currentPage={page}
              rangeLimit={rangeLimit}
              handlePaginationChange={handlePaginationChange}
              pageUrl={`/${itemId}/`}
            />
          )}
          <AckodriveBreadCrumb breadCrumbObj={breadcrumb} />

          {!isLoggedIn && (
            <>
              <Divider />
              {page !== 1 && <RecentItems recentItems={recentPosts} itemId={itemId} itemType={itemType} />}
              {topicsData?.length > 0 && <TopicsPanel data={topicsData} />}
            </>
          )}
        </div>
        <RightContainer>
          <RightStickyContainer isMobile={isMobileDevice}>
            <CallbackWidgetExplore>
              <CallbackWidget isMobile={isMobileDevice} />
            </CallbackWidgetExplore>
            <RecentItemsContainer isMobile={isMobileDevice}>
              <RecentItemPosts posts={recentPosts} itemId={itemId} />
            </RecentItemsContainer>
          </RightStickyContainer>
        </RightContainer>
      </ItemListingContentWrapper>
      <AckodriveBreadCrumb breadCrumbObj={breadcrumb} />
    </ItemsListingWrapper>
  )
}

export default ItemListing
